/*------------------------------------*\
    account
\*------------------------------------*/
module.exports = function(){



    /*------------------------------------*\
        imports
    \*------------------------------------*/
    var checkout = require('./checkout-functions.js');
    var productsNeedMeasurements = checkout.productsNeedMeasurements;



    var isLoggedIn = localStorage.getItem('is_logged_in');

    if (window.globalCustomerId && (! isLoggedIn || isLoggedIn == 'false')) {

        console.info('Log in state change.', 'setting to true');
        localStorage.setItem('is_logged_in', true);

        // sync cart here
        window.eph.getBackendCartItems(() => {
            if (lsCart.getAllItems() && window.cartBackend.length) { // found items on local, and on backend

                console.info('found items on local, and on backend');
                        console.info('choosing backend over local');
                        lsCart.removeAll();
                        window.cartBackend.length && Object.keys(window.cartBackend).forEach(
                            (cartIndex) => lsCart.addItem(JSON.parse(window.cartBackend[cartIndex].JsCartObject), true, false) // do not fire events!!
                        );
                // alertify.confirm('We found previous items saved in your cart. Would you like to replace current cart by the saved one?', () => {
                //
                //     }, () => {
                //         console.info('choosing local over backend');
                //         checkout.addLocalProductsToBackendCart(() => {}, false);
                // })

            } else if (lsCart.getAllItems() && ! window.cartBackend.length) { // found items on local, no backend

                console.info('found items on local, no backend');
                checkout.addLocalProductsToBackendCart(() => {}, false);

            } else if (! lsCart.getAllItems() && window.cartBackend.length) { // found items on backend, no local

                console.info('found items on backend, no local');
                Object.keys(window.cartBackend).forEach(
                    (cartIndex) => lsCart.addItem(JSON.parse(window.cartBackend[cartIndex].JsCartObject), true, false) // do not fire events!!
                );

            }
        });

    } else if (! window.globalCustomerId && (isLoggedIn || isLoggedIn == 'true')) {

        console.info('Log in state change.', 'setting to false');
        localStorage.setItem('is_logged_in', false);

    }


    /*------------------------------------*\
        If cart (page) is empty redirect to
        home page
    \*------------------------------------*/
    if ($('[js-cart-page]').length) {
        if ( !Object.keys( lsCart.getAllItems() ).length ) {
            window.location.href = WP_SITEURL;
            alertify
            .alert('Your cart is empty. Redirecting you back to home page.')
            .reset();
        }
    }




    /*------------------------------------*\
        checkout checks
    \*------------------------------------*/
    $(document).on('click', '[js-cart-checkout-btn]', function(event) {

        // is logged in?
        if ( ! globalCustomerId ) {
            event.preventDefault();

            var redirectToCheckoutFitting = (!globalCustomerHasMeasurementProfiles) && productsNeedMeasurements();

            if (redirectToCheckoutFitting) {
                window.openModalWithText('login', 'Please login to continue.', '/checkout-fitting/');
            } else {
                window.openModalWithText('login', 'Please login to continue to checkout.', '/checkout/');
            }

            return false;
        }





        // checking for address before checking out
        /*
        if (!globalCustomerHomeAddresId) {
            event.preventDefault();


            alertify
            .okBtn('Set Address')
            .cancelBtn('Cancel')
            .confirm(
                    'Before you checkout, please provide us with your shipping address in your account profile.',
                function () {
                    window.location.href = WP_SITEURL + '/profile/';
                }, function() {
                }
            );
            alertify.reset();

            return false;
        }
        */







        /*------------------------------------*\
            Cart sidebar btn click checks
            check if there's a need for measurement
            profile
        \*------------------------------------*/
        if ( globalCustomerId  && (!globalCustomerHasMeasurementProfiles) && productsNeedMeasurements()) {


            alertify
            .okBtn('Proceed')
            .cancelBtn('Cancel')
            .confirm(
                    'Some items in your cart require your measurements. We will redirect you now to the Checkout Fitting page where you will be able to create your measurement profile.',
                function () {
                    window.location.href = WP_SITEURL + '/checkout-fitting/';
                },
            );
            alertify.reset();

            event.preventDefault();
            return false;

        }








        return true;


    });






}; // end of module.exports



// WEBPACK FOOTER //
// ./js-source/integration/checks.js